<div class="login">

  <!-- Right panel: form -->
  <div class="login__panel login__panel--right">

    <div *ngIf="linkMissing" class="login-form">
      <div class="login-form__field">
        <h2 class="login-form__label">Invalid reset link</h2>
        <p class="login-form__hint">This link is missing its token. Request a new one below.</p>
      </div>
      <div class="login-form__actions">
        <a routerLink="/forgot-password" class="btn btn--primary">Request a new link</a>
      </div>
    </div>

    <form *ngIf="!linkMissing" class="login-form" [formGroup]="form" (ngSubmit)="submit()" novalidate>

      <div class="login-form__field">
        <h2 class="login-form__label">Set a new password</h2>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="password">New Password</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="password"
            id="password"
            formControlName="password"
            placeholder="At least 6 characters"
            autocomplete="new-password"
          />
        </div>
      </div>

      <div class="login-form__field">
        <label class="login-form__label" for="password-confirmation">Confirm New Password</label>
        <div class="login-form__input-wrap">
          <input
            class="login-form__input"
            type="password"
            id="password-confirmation"
            formControlName="password_confirmation"
            placeholder="Repeat password"
            autocomplete="new-password"
          />
        </div>
        <p class="login-form__error" *ngIf="passwordMismatch">Passwords don't match.</p>
      </div>

      <div class="login-form__actions">
        <button class="btn btn--primary" type="submit" [disabled]="isLoading">Update password</button>
        <p class="login-form__footer">
          Remembered it? <a routerLink="/login" class="link">Back to sign in</a>
        </p>
      </div>

    </form>

  </div>

  <!-- Left panel: branding mosaic -->
  <div class="login__panel login__panel--left">
    <app-auth-panel></app-auth-panel>
  </div>

</div>
